/**
 * Dawn theme: filter the THUMBNAIL row by filename, based on the
 * currently selected variant option (e.g. Color). The main swipeable
 * image is left alone — Dawn's own built-in variant-media logic
 * already jumps it straight to the right photo, and fighting that
 * with our own hide/show caused a visible scroll "jump". Make sure
 * theme settings > "Hide other variant media after one is selected"
 * is turned ON so the main image behaves correctly too.
 *
 * HOW TO USE
 * 1) Name your image files so they contain the option value as a
 *    distinct segment, separated by "-", "_", or ".", e.g.:
 *      MILAN-133-1.jpg, MILAN-133-2.jpg, MILAN-134-1.jpg ...
 *    Shopify may append a random hash on upload (e.g.
 *    MILAN-133-4_42a1f846-....jpg) — that's fine, the script still
 *    matches "MILAN-133" as long as it's a whole delimited segment.
 * 2) Set CONFIG.optionName below to the exact Shopify option name
 *    (matched against each input's data-option-name attribute).
 *    Leave it as '' to filter on whichever option was just changed.
 * 3) Include this file on product pages (see setup instructions).
 */
(function () {
  var CONFIG = {
    optionName: 'color',
    // Only the thumbnail row is filtered — the main slider is left
    // untouched so Dawn's own scroll-to-active-media logic isn't
    // fought over.
    itemSelector: '.thumbnail-list__item',
  };

  var style = document.createElement('style');
  style.textContent = '.variant-image-hidden{display:none !important;}';
  document.head.appendChild(style);

  function normalize(str) {
    return (str || '').toLowerCase().trim();
  }

  function tokensFor(value) {
    var base = normalize(value);
    return [
      base.replace(/\s+/g, '-'),
      base.replace(/\s+/g, '_'),
      base.replace(/\s+/g, ''),
    ];
  }

  function filenameOf(img) {
    if (!img) return '';
    var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
    var clean = src.split('?')[0];
    return normalize(clean.substring(clean.lastIndexOf('/') + 1));
  }

  function filenameHasToken(filename, token) {
    if (!token) return false;
    var escaped = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('(^|[-_.])' + escaped + '([-_.]|$)');
    return re.test(filename);
  }

  function resetScrollPositions(gallery) {
    var lists = gallery.querySelectorAll(
      'ul.thumbnail-list, ul[id^="Slider-Thumbnails-"]'
    );
    lists.forEach(function (list) {
      list.scrollLeft = 0;
    });
  }

  function applyFilter(root, tokens) {
    var galleries = root.querySelectorAll('media-gallery');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      var items = gallery.querySelectorAll(CONFIG.itemSelector);
      var matches = new Map();
      var anyMatch = false;

      items.forEach(function (item) {
        var img = item.querySelector('img');
        var fname = filenameOf(img);
        var isMatch = tokens.some(function (t) {
          return filenameHasToken(fname, t);
        });
        matches.set(item, isMatch);
        if (isMatch) anyMatch = true;
      });

      items.forEach(function (item) {
        var isMatch = matches.get(item);
        if (!anyMatch || isMatch) {
          item.classList.remove('variant-image-hidden');
        } else {
          item.classList.add('variant-image-hidden');
        }
      });

      resetScrollPositions(gallery);
    });
  }

  // Dawn's variant radios/selects live OUTSIDE the <form> element
  // (linked to it only via a form="..." attribute), so we can't use
  // form.querySelector or event.target.closest('form') to find them.
  // Instead we read data-option-name directly off the input, and
  // scope the gallery lookup via the shared <product-info> ancestor
  // that wraps both the variant picker and the media gallery.

  function scopeFor(el) {
    return el.closest('product-info') || document;
  }

  function isRelevantInput(input) {
    if (!input || !input.hasAttribute) return false;
    if (!input.hasAttribute('data-option-name')) return false;
    if (!CONFIG.optionName) return true;
    return (
      normalize(input.getAttribute('data-option-name')) ===
      normalize(CONFIG.optionName)
    );
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input.tagName === 'SELECT') {
      if (!isRelevantInput(input)) return;
      applyFilter(scopeFor(input), tokensFor(input.value));
      return;
    }
    if (input.tagName !== 'INPUT' || input.type !== 'radio' || !input.checked) return;
    if (!isRelevantInput(input)) return;
    applyFilter(scopeFor(input), tokensFor(input.value));
  });

  function initAll() {
    document.querySelectorAll('product-info').forEach(function (productInfo) {
      var checked = productInfo.querySelector(
        'input[type="radio"][data-option-name]:checked, select[data-option-name]'
      );
      if (!checked) return;
      applyFilter(productInfo, tokensFor(checked.value));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
